import {styled} from '@mui/material';

export const InnerContainer = styled('div')(() => ({
  padding: '30px 20px',
}));

export const FieldContainer = styled('div')(() => ({
  marginBottom: 20,
}));
